import { render, staticRenderFns } from "./AffordabilityPreviewBar.vue?vue&type=template&id=40122670&scoped=true"
import script from "./AffordabilityPreviewBar.vue?vue&type=script&lang=js"
export * from "./AffordabilityPreviewBar.vue?vue&type=script&lang=js"
import style0 from "./AffordabilityPreviewBar.vue?vue&type=style&index=0&id=40122670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40122670",
  null
  
)

export default component.exports